<div class="pageheader">
  <div class="page-title">
    <h1>File compare</h1>
  </div>
  <div class="btn-toolbar">
    @if (documentIdForActual() !== 0) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="openDocuments()">Open document in new window</button>
    </div>
    }
    @if (testRunId() !== 0) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="rerunTestRun()">Run test case again</button>
    </div>
    }
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="switchParsedState()">{{switchParsedButtonText()}}</button>
    </div>
    @if (testRunDocumentsId() !== 0) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="downloadAllTestRunFiles()">Download test files</button>
    </div>
    }
    @if (canNavigateToTestCase()){
      <div class="btn-group">
        <button class="btn btn-primary btn-sm" (click)="viewTestCaseRowEvent()" hint="Go to Test Case">Test Case</button>
      </div>
    }
    @if (canAcceptDifferences()) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="acceptDifferences()">Accept differences</button>
    </div>
    }
    @if (canRejectDifferences()) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="rejectDifferences()">Reject differences</button>
    </div>
    }
  </div>
</div>

<div class="fullscreen">
  @if (currentResultNumber() !== 0) {
  <div class="result-number-container">
    <h3>Result number: {{currentResultNumber()}}</h3>
    <div class="btn-group" data-toggle="buttons">
      <button class="btn btn-link" (click)="previousResultNumber()">
        Previous <ep-svg-icon icon="circle-chevron-left"></ep-svg-icon>
      </button>
      <button class="btn btn-link" (click)="nextResultNumber()">
        Next <ep-svg-icon icon="circle-chevron-left" extraClasses="mirror"></ep-svg-icon>
      </button>
    </div>
  </div>
  }
  <app-visual-compare [left]="expected().Content" [right]="actual().Content" [language]="language">
    <div left>
      <app-test-tool-file-info title="Expected file" [differencesAccepted]="this.acceptState().Accepted" [file]="expected()" [compareTo]="actual()" color="#ffa3a3"></app-test-tool-file-info>
    </div>
    <div right>
      <app-test-tool-file-info title="Actual file" [file]="actual()" [compareTo]="expected()" color="#d7e8b0"></app-test-tool-file-info>
    </div>
  </app-visual-compare>
</div>
